module.exports = {
	"header": "Abonnement",
	"addMore": "Si vous voulez en ajouter plus, vous devez hausser votre abonnement.",
	"downgradeConfirmation": "Êtes-vous certain de vouloir rétrograder votre plan?",
	"downgradePlan": "Rétrograder le plan",
	"expiresOn": "Expire le",
	"immediatePlanChanges": "Les changement de plan sont immédiats.",
	"lotsPerAuction": "Lots par encan",
	"nextRenewal": "Prochain renouvellement le",
	"picturesPerLot": "Photos par lot",
	"plan": "Plan",
	"pricing": "Tarif",
	"switchMonthly": "Changer à la facturation mensuelle",
	"switchYearly": "Changer à la facturation annuelle",
	"updated": "Abonnement mise à jour avec succès.",
	"update": "Mettre à jour l'abonnement.",
	"upgradeSubscriptionLink": "Vous pouvez voir les abonnements disponibles <subscriptionLink>$t(general::here)</subscriptionLink>",
	"yourPlan": "Votre plan"
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/fr/subscription.json5
// module id = 2011
// module chunks = 6